// extracted by mini-css-extract-plugin
export default {"container":"SquareAdmis_container__VZG4o","header":"SquareAdmis_header__XHjAq","closeBtn":"SquareAdmis_closeBtn__yh7N5","formContainer":"SquareAdmis_formContainer__+TCYi"};